<template>
  <ul class="v-breadcrumbs sticky-breadcrumb px-2 py-2" v-if="!$store.state.isOffline && breadcrumb">
    <li class="v-breadcrums__item" v-for="(bc,i) in breadcrumb" :key="i">
      <template v-if="i != breadcrumb.length  - 1">
        <small><a @click="$router.push(bc.to)">{{bc.name}}</a> / </small>
      </template>
      <template v-else>
        <small>{{bc.name}}</small>
      </template>
    </li>
  </ul>
</template>


<script>
export default {
  name: "BackButton",
  data() {
    return {};
  },
  computed: {
    breadcrumb() {
      return this.$store.state.breadcrumb;
    }
  },
  methods: {},
  watch: {
    breadcrumb(n, o) {}
  },
  created() {}
};
</script>

<style scoped>
.unstyled {
  list-style-type: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Breadcrumb.vue